<template>

    <div class="bg-white overflow-hidden shadow rounded-lg relative pb-20">

        <div class="flex p-5 items-center">
            <h2 class="flex-1 text-lg font-medium leading-6 text-gray-900">
                Account Funds
            </h2>
        </div>

        <div class="px-5">
            <div class="h-60 overflow-y-scroll" v-if="funds">
                <table class="w-full">
                    <tbody>
                    <tr class="colored-row" v-for="fund in funds">
                        <td class="w-3/6 px-3 py-1 text-sm">
                            <div class="flex items-center">
                                <div class="flex-shrink-0">
                                    <img :src="fund.currency_icon" class="w-6">
                                </div>
                                <div class="ml-5 w-0 flex-1">
                                    <dl>
                                        <dt class="text-sm font-medium text-gray-500 truncate">
                                            {{ fund.type }} {{ fund.currency }}
                                        </dt>
                                        <dd>
                                            <div v-if="value.data.has_unlimited_funds">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" viewBox="0 0 1280 640"><path d="M963.8 32.5c-77.2 9.3-150.4 46.7-231.7 118.4-19.8 17.4-33.4 30.3-65.7 62.4-23 22.9-26.4 25.8-28.1 24.9-1.1-.6-10-9.3-19.9-19.4C504 101.7 429.8 52.4 343.9 36.6c-56-10.3-114.1-3.8-166.9 18.6C88.5 92.8 23.7 171.9 5.6 264.5 1.5 285.2.5 296.3.5 321c0 39.2 5.4 71.9 17.6 106.5 33.8 96.4 114.5 162.7 216.4 177.9 63.4 9.5 133.7-2.6 195.7-33.5 24.3-12.1 44.8-25 70.3-44.1 32.1-23.9 55.6-45 106.1-95 17.6-17.5 32.7-31.8 33.4-31.8.8 0 7.7 6.6 15.4 14.6 17.2 17.9 59.2 58.4 77 74.3 82 73.1 144.2 105.5 222.6 116.3 5.8.8 19.4 1.2 35 1.2 21.3 0 27.9-.4 40-2.3 65-10 120.5-37.9 165.9-83.2 45.7-45.7 74.2-104.5 82.3-169.9 1.9-15.5 1.6-56.3-.6-72-7.8-56.1-27.5-106.7-56.8-145.7-9.5-12.8-29.4-33.2-42.5-43.5-36.4-29-83.7-48.6-137.8-57-17.2-2.6-59.4-3.4-76.7-1.3zM330.7 152.4c33.6 7.1 67.6 23.3 101 48.1 11.9 8.8 29.7 23.4 41.3 33.9 14.6 13.3 88 85 88 86 0 1.6-64 64.9-79.5 78.8-49.2 43.8-94.7 71.5-137.5 83.9-20.2 5.8-32.1 7.4-56.5 7.4-19 0-23.5-.3-33.4-2.3-59-11.9-102.2-50.4-121-107.7-16-48.9-13-95.3 9-138.5 25.2-49.6 70.6-82.4 126.6-91.5 6.3-1 14.6-1.3 29.3-1 17.2.3 22.5.8 32.7 2.9zm686.3-1.9c32.7 4.6 60.5 17.1 84.1 37.8 43.9 38.4 64.9 106.3 51.7 167.7-13.4 62.5-61.5 113.1-122.9 129.5-14.8 3.9-27.9 5.5-45.4 5.5-31 0-55.9-6.2-87-21.5-32.7-16-64.2-39.1-103.7-76.1-24.8-23.2-74.3-71.9-74.6-73.4-.3-1.6 46.6-49.5 66.8-68.1 68.2-63 122.1-93.3 180-101.4 13-1.8 38.2-1.8 51 0z"/></svg>
                                            </div>
                                            <div class="text-lg font-medium text-gray-900" v-else>
                                                {{ formatCurrency(fund.currency, fund.amount / 100) }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </td>
                        <td class="w-2/6 px-3 py-1 text-sm text-gray-400">
                            <span v-if="fund.last_updated">
                                Last updated {{ formatDate(fund.last_updated) }}
                            </span>
                            <span v-else>
                                No previous activity
                            </span>
                        </td>
                        <td class="w-1/6 px-3 py-1">
                            <router-link :to="{ name: 'manage-funds.adjust', params: { 'account': value.data.id ,'fund': fund.id } }" custom v-slot="{ navigate }" :disabled="value.data.has_unlimited_funds">
                                <button @click="navigate" type="button" class="btn-outline text-xs px-2 py-1">
                                    Adjust
                                </button>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex h-60 items-center justify-center" v-else>
                <h2 class="text-gray-600 font-medium text-lg text-center py-24">No Account Funds</h2>
            </div>
        </div>
    </div>

</template>

<script>

import {FormattingMixin} from "../../support/mixins";

export default {
    props: {
        value: {
            required: true
        },
        funds: {
            required: true,
        },
    },
    name: "AccountFunds",
    mixins: [FormattingMixin],
}
</script>


